<template>
  <div v-if="showProjectSwitcher" :style="containerStyle">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <span
          class="project-filter align-center d-flex"
          v-bind="attrs"
          v-on="on"
          :style="activatorStyle"
        >
          {{ activeLabel }}
        </span>
      </template>

      <v-list class="project-filter-list">
        <v-list-item
          v-for="opt in projectOptions"
          :key="opt.value"
          @click="onSwitch(opt.value)"
        >
          <v-list-item-title>
            {{ opt.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ADD_ALERT } from "@/store/_actiontypes";

export default {
  name: "ProjectSwitcher",
  computed: {
    ...mapGetters("project", [
      "activeProjectKey",
      "projectOptions",
      "showProjectSwitcher",
    ]),
    containerStyle() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return "width:100%;";
      }
      return "min-width:160px; max-width:200px;";
    },
    activatorStyle() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return "width:100%;";
      }
      return "width:200px;";
    },
    activeLabel() {
      const match = this.projectOptions.find((o) => o.value === this.activeProjectKey);
      return match?.text || "Select project";
    },
  },
  data() {
    return {
      switching: false,
    };
  },
  methods: {
    ...mapActions("project", ["SWITCH_PROJECT"]),
    ...mapActions("alert", [ADD_ALERT]),
    async onSwitch(key) {
      if (this.switching) return;
      if (!key || key === this.activeProjectKey) return;

      this.switching = true;
      try {
        await this.SWITCH_PROJECT(key);
      } catch (_) {
        this.ADD_ALERT({
          message: "You don't have permission for that project",
          color: "error",
        });
      } finally {
        this.switching = false;
      }
    },
  },
};
</script>

<style scoped>
.project-filter {
  height: 40px;
  border-radius: 8px;
  padding: 0 16px;
  border-width: 0.5px;
  background: #ffffff33;
  border: 0.5px solid #cccccc;
  backdrop-filter: blur(20px);
  color: #222222;
  cursor: pointer;

  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23222222'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
}

.project-filter-list {
  padding: 5px;
  background: white;
}
</style>
